import { mutate } from "swr";
import { NewsFeedArticle, LIMIT, ActivityAction } from "core/feed/types";
import { NEWS_FEED_ENDPOINT } from "core/feed/useNews";
import { call } from "lib/http/call";
import { MethodType, ResponseStatus } from "lib/http/types";
import { ServiceEndpoints } from "lib/http/constants";
import { encodeToSnakeCase } from "lib/http/formatForServer";

interface MutateFeedParams {
  feed: NewsFeedArticle[];
  refId: string;
  liked: boolean;
}

export async function mutateFeedArticle(
  options: MutateFeedParams
): Promise<NewsFeedArticle[]> {
  const { feed, refId, liked } = options;
  let endpointPage = 0;
  const output = feed.map((article: NewsFeedArticle, index: number) => {
    if (article.ref_id === refId) {
      const currentLikes = article.num_likes ?? 0;
      const newLikes = liked ? currentLikes + 1 : currentLikes - 1;
      endpointPage = index === 0 ? 0 : Math.floor(index / LIMIT);
      return {
        ...article,
        num_likes: newLikes,
        usr_liked: liked ? true : false,
      };
    }
    return article;
  });

  const newSection = output.slice(
    endpointPage * LIMIT,
    (endpointPage + 1) * LIMIT
  );
  const fullendpoint = `${NEWS_FEED_ENDPOINT}?limit=${LIMIT}&offset=${endpointPage}`;
  await mutate(fullendpoint, newSection, false);
  return output;
}

export interface FeedQueryParams {
  index?: number;
  limit?: number;
  query?: string;
}

export function setupQueryParams(params: FeedQueryParams): string {
  const { index, limit, query } = params;
  let queryParams = `?limit=${limit}&offset=${(index ?? 0) * (limit ?? 25)}`;

  if (!query) {
    return queryParams;
  }
  if (query && query.length > 0) {
    const searchVal = query.trim().split(" ").join("+");
    queryParams += `&q=${searchVal}`;
  }
  return queryParams;
}

interface NewsActivityParams {
  activity: ActivityAction;
  refId: string;
}

type ActivityResponse =
  | { type: ResponseStatus.SUCCESS }
  | { type: ResponseStatus.ERROR; error: string };

export async function handleNewsActivity(
  params: NewsActivityParams
): Promise<ActivityResponse> {
  const { activity, refId } = params;
  const postBody = {
    action: activity,
  };
  const result = await call({
    body: JSON.stringify(encodeToSnakeCase(postBody)),
    endpoint: `${ServiceEndpoints.NEWS}/v1/maritime/news/${refId}/activity`,
    method: MethodType.POST,
  });
  if (result.status === ResponseStatus.SUCCESS) {
    return {
      type: ResponseStatus.SUCCESS,
    };
  }
  return {
    error: "error",
    type: ResponseStatus.ERROR,
  };
}
